import React, { Component } from 'react';
import RkHeader from "./RkHeader"
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import FormCreate from '../components/formatos/Formats/FormCreate';
import RiskPagination from '../components/risk/RiskPagination';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

class RiskConfigIndex extends Component {
    constructor(props){
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            id: "",
            modal: false,
            page: 1,
            perPage: 10,
            form: {
                name: ""
            },

            formUpdate: {
                name: ""
            }
        }
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    clearValues = () => {
        this.setState({
            id: "",
            form: {
                name: ""
            },

            formUpdate: {
                name: ""
            }
        })
    }

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    validationForm = () => {
        if (this.state.form.name != ""
            ) {
            this.setState({ ErrorValues: true })
            return true
        }else{
            this.setState({ ErrorValues: false })
            return false
        }
    }

    HandleClick = () => {
        if(this.validationForm() == true){
            fetch(`${this.props.urlCreate}`, {
                    method: 'POST', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
            })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                this.clearValues();
                this.props.updateData(data.register)
                this.setState({ modal: false })
                this.messageSuccess(data);
            });
        }
    }

    HandleClickUpdate = () => {
        fetch(`${this.props.urlUpdate}${this.state.id}`, {
            method: 'PATCH', // or 'PUT'
            body: JSON.stringify(this.state.formUpdate), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            this.clearValues();
            this.props.updateItem(data.register)
        });
    }

    HandleChangeUpdate = (e) => {
        this.setState({
            formUpdate: {
                ...this.state.formUpdate,
                name: e.target.value
            }
        })
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                name: e.target.value
            }
        })
    }

    edit = (config) => {
        this.setState({
            id: config.id,

            formUpdate: {
                name: config.name
            }
        })
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`${this.props.urlDelete}${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(response => response.json())
                .then(response => {
                    this.props.loadData()
                    this.messageSuccess(response)
                });
            }
        });
    };

    render() {
        const data = this.props.data || [];
        const total = data.length;
        const totalPages = Math.max(1, Math.ceil(total / this.state.perPage));
        const page = Math.min(this.state.page, totalPages);
        const pageData = data.slice((page - 1) * this.state.perPage, page * this.state.perPage);
        const showActions = this.props.estados.editar || this.props.estados.eliminar || this.props.estados.gestionar;

        return (
            <React.Fragment>
                <RkHeader
                    title={`${this.props.headerTitleName}`}
                    subtitle={"Configuración de riesgos"}
                    titleNew={"Nuevo"}
                    icon="fas fa-toolbox"
                    onClickNew={this.toogle}
                    showNew={this.props.estados.crear}
                    showFilter={false}
                />

                {this.state.modal && (
                    <FormCreate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={"Nuevo"}

                        //form props
                        formValues={this.state.form}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                    />
                )}

                {/*<nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <a 
                                href={"/risk/activities"}
                                data-turbolinks="true"
                            >
                                {"Actividad de riesgos"}
                            </a>
                        </li>

                        <li className="breadcrumb-item">
                            <a 
                                href={`/risk/criterios`}
                                data-turbolinks="true"
                            >
                                {"Criterios"}
                            </a>
                        </li>
                    </ol>
                </nav>*/}

                <div className="rk-wrap">
                    <div className="rk-table-card">
                        <div className="rk-table-scroll">
                            <table className="rk-table">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        {(this.props.estados.editar || this.props.estados.eliminar || this.props.estados.gestionar) && (
                                            <th className="rk-table__actions"></th>
                                        )}
                                    </tr>
                                </thead>

                                <tbody>
                                    {total >= 1 ? (
                                        pageData.map(config => (
                                            <tr key={config.id}>
                                                <td>
                                                    {config.id == this.state.id ? (
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            value={this.state.formUpdate.name}
                                                            onChange={this.HandleChangeUpdate}
                                                            className="rk-input rk-input--inline"
                                                        />
                                                    ) : (
                                                        <span className="rk-cell-primary">{config.name}</span>
                                                    )}
                                                </td>
                                                {(this.props.estados.editar || this.props.estados.eliminar || this.props.estados.gestionar) && (
                                                    <td className="rk-table__actions">
                                                        {this.state.id != "" ? (
                                                            config.id == this.state.id && (
                                                                <span className="rk-inline-actions">
                                                                    <button type="button" className="rk-inline-btn rk-inline-btn--ok" onClick={() => this.HandleClickUpdate()}>
                                                                        <i className="fas fa-check"></i>
                                                                    </button>
                                                                    <button type="button" className="rk-inline-btn rk-inline-btn--cancel" onClick={() => this.setState({ id: "" })}>
                                                                        <i className="fas fa-times"></i>
                                                                    </button>
                                                                </span>
                                                            )
                                                        ) : (
                                                            <UncontrolledDropdown>
                                                                <DropdownToggle tag="button" className="rk-icon-btn">
                                                                    <i className="fas fa-ellipsis-v"></i>
                                                                </DropdownToggle>
                                                                <DropdownMenu right className="rk-menu">
                                                                    {this.props.estados.gestionar && (
                                                                        <DropdownItem
                                                                            href={`configuration/${config.id}/${this.props.headerTitleName == "Criterios" ? "criterios" : "actividad"}`}
                                                                            data-turbolinks="true"
                                                                            target="_blank"
                                                                        >
                                                                            <i className="fas fa-th"></i> Matriz de riesgos y oportunidades
                                                                        </DropdownItem>
                                                                    )}
                                                                    {this.props.estados.editar && (
                                                                        <DropdownItem onClick={() => this.edit(config)}>
                                                                            <i className="fas fa-pen"></i> Editar
                                                                        </DropdownItem>
                                                                    )}
                                                                    {this.props.estados.eliminar && (
                                                                        <DropdownItem className="rk-danger" onClick={() => this.delete(config.id)}>
                                                                            <i className="fas fa-trash"></i> Eliminar
                                                                        </DropdownItem>
                                                                    )}
                                                                </DropdownMenu>
                                                            </UncontrolledDropdown>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={(this.props.estados.editar || this.props.estados.eliminar || this.props.estados.gestionar) ? 2 : 1}>
                                                <div className="rk-empty">
                                                    <i className="far fa-folder-open"></i>
                                                    <p>No hay registros</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <RiskPagination
                            page={page}
                            perPage={this.state.perPage}
                            total={total}
                            onPage={(p) => this.setState({ page: p })}
                            onPerPage={(n) => this.setState({ perPage: n, page: 1 })}
                        />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default RiskConfigIndex;